/**
 * 스캔 화면 공용 색 — 라이브 검출 점·정지 화면 모델/사용자 기준선이 공유한다.
 *
 * 코너 점 색은 **카드의 위 모서리(코너 0,1) / 아래 모서리(코너 2,3)** 를 구분한다 —
 * 뒤집힌 카드 라벨링 시 모듈이 어느 변을 '위'로 판단했는지 보여주기 위함 (사용자 지시).
 * 8접점 outline 에서는 outline[2i], outline[2i+1] 이 코너 i 소속 → 위 = idx 0..3, 아래 = idx 4..7.
 */
export const CORNER_TOP_COLOR = "#ff8a3d"; // 위 모서리 — 주황
export const CORNER_BOTTOM_COLOR = "#4fc3f7"; // 아래 모서리 — 하늘
export const MODEL_LINE_COLOR = "#3ddc84"; // 모델(테두리 인식) 기준선 — 초록
export const USER_LINE_COLOR = "#8a8af0"; // 사용자 라벨링 선 — 보라

/** 8접점 outline 인덱스가 카드 위 모서리 소속인지 (코너 0,1 = idx 0..3) */
export const isTopOutlineIndex = (i: number) => i < 4;
/** quad 코너 인덱스가 위 모서리인지 (TL=0, TR=1) */
export const isTopCornerIndex = (i: number) => i < 2;
